export default [{
  // Questions
  component: function component() {
    return import('pages/Questions');
  },
  meta: {
    layout: 'Survey',
    title: 'route.questions'
  },
  path: '/questions'
}];